import React from "react";
import PropTypes from "prop-types";

export const Calender = ({ color = "#333" }) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="calendar-alt-solid">
        <path
          id="Vector"
          d="M3.90909 1V1.69565H1V17H17V1.69565H14.0909V1H12.6364V1.69565H5.36364V1H3.90909ZM2.45455 3.08696H3.90909V3.78261H5.36364V3.08696H12.6364V3.78261H14.0909V3.08696H15.5455V4.47826H2.45455V3.08696ZM2.45455 5.86957H15.5455V15.6087H2.45455V5.86957ZM6.81818 7.26087V8.65217H8.27273V7.26087H6.81818ZM9.72727 7.26087V8.65217H11.1818V7.26087H9.72727ZM12.6364 7.26087V8.65217H14.0909V7.26087H12.6364ZM3.90909 10.0435V11.4348H5.36364V10.0435H3.90909ZM6.81818 10.0435V11.4348H8.27273V10.0435H6.81818ZM9.72727 10.0435V11.4348H11.1818V10.0435H9.72727ZM12.6364 10.0435V11.4348H14.0909V10.0435H12.6364ZM3.90909 12.8261V14.2174H5.36364V12.8261H3.90909ZM6.81818 12.8261V14.2174H8.27273V12.8261H6.81818ZM9.72727 12.8261V14.2174H11.1818V12.8261H9.72727Z"
          fill="black"
        />
      </g>
    </svg>
  );
};

Calender.propTypes = {
  color: PropTypes.string,
};
